<template>
  <b-form @submit.prevent="onSubmit">
    <b-row>
      <b-col>
        <form-group :validations="$v.form.name">
          <div slot-scope="{ errors, invalid }">
            <b-form-group
              id="input-group-1"
              label="نام"
              label-for="input-1"
              description=""
            >
              <b-form-input
                id="input-1"
                v-model="form.name"
                placeholder="نام"
                :class="{ invalid }"
              ></b-form-input>
              <form-errors-manager :errors="errors" />
            </b-form-group>
          </div>
        </form-group>

        <form-group :validations="$v.form.code">
          <div slot-scope="{ errors, invalid }">
            <b-form-group
              id="input-group-1"
              label=" کد تخفیف"
              label-for="input-1"
              description=""
            >
              <b-form-input
                id="input-1"
                v-model="form.code"
                placeholder="کد تخفیف"
                :class="{ invalid }"
              ></b-form-input>
              <form-errors-manager :errors="errors" />
            </b-form-group>
          </div>
        </form-group>

        <form-group :validations="$v.form.price">
          <div slot-scope="{ errors, invalid }">
            <b-form-group
              id="input-group-1"
              label=" قیمت"
              label-for="input-1"
              description=""
            >
              <b-form-input
                id="input-1"
                v-model="form.price"
                placeholder="قیمت"
                :class="{ invalid }"
              ></b-form-input>
              <form-errors-manager :errors="errors" />
            </b-form-group>
          </div>
        </form-group>

        <form-group :validations="$v.form.on_delivery_price">
          <div slot-scope="{ errors, invalid }">
            <b-form-group
              id="input-group-1"
              label=" تخفیف روی تحویل"
              label-for="input-1"
              description=""
            >
              <b-form-input
                id="input-1"
                v-model="form.on_delivery_price"
                placeholder="ندارد"
                :class="{ invalid }"
              ></b-form-input>
              <form-errors-manager :errors="errors" />
            </b-form-group>
          </div>
        </form-group>

        <form-group :validations="$v.form.HowManyCanBeUsed">
          <div slot-scope="{ errors, invalid }">
            <b-form-group
              id="input-group-1"
              label="تعداد قابل استفاده"
              label-for="input-1"
              description=""
            >
              <b-form-input
                id="input-1"
                v-model="form.HowManyCanBeUsed"
                placeholder="تعداد قابل استفاده"
                :class="{ invalid }"
              ></b-form-input>
              <form-errors-manager :errors="errors" />
            </b-form-group>
          </div>
        </form-group>

        <form-group :validations="$v.form.active_at">
          <div slot-scope="{ errors, invalid }">
            <b-form-group
              id="input-group-1"
              label="فعال سازی در تاریخ"
              label-for="input-1"
              description=""
            >

              <vue-persian-datetime-picker 
                id="input-1"
                placeholder="فعال سازی در تاریخ"
                inputFormat= "YYYY-MM-DD HH:mm"
                displayFormat= 'jYYYY-jMM-jDD HH:mm'
                type="datetime"
                v-model="form.active_at"
                :class="{ invalid }" />

              <form-errors-manager :errors="errors" />
            </b-form-group>
          </div>
        </form-group>

        <form-group :validations="$v.form.expire_at">
          <div slot-scope="{ errors, invalid }">
            <b-form-group
              id="input-group-1"
              label="انقضا در تاریخ"
              label-for="input-1"
              description=""
            >

              <vue-persian-datetime-picker 
                id="input-1"
                placeholder="انقضا در تاریخ"
                inputFormat= "YYYY-MM-DD HH:mm"
                displayFormat= 'jYYYY-jMM-jDD HH:mm'
                type="datetime"
                v-model="form.expire_at"
                :min="form.active_at"
                :class="{ invalid }" />

              <form-errors-manager :errors="errors" />
            </b-form-group>
          </div>
        </form-group>        
      </b-col>
    </b-row>

    <b-row>
      <b-col>
        <form-group :validations="$v.form.offerable_type" >
          <div slot-scope="{ errors, invalid }">
            <b-form-group id="input-group-2" label="تخفیف روی" label-for="input-2">
              <b-form-select
                v-model="form.offerable_type"
                :options="types"
              ></b-form-select>
              <form-errors-manager :errors="errors" />
            </b-form-group>
          </div>
        </form-group>
      </b-col>

      <b-col>
        <form-group :validations="$v.form.offerable_id">
          <div slot-scope="{ errors, invalid }">
            <b-form-group
              id="input-group-1"
              label="جستجو"
              label-for="input-1"
              description=""
            >
              <b-form-input
                id="input-1"
                placeholder="جستجو"
                v-model="form.offerable_id"
                :disabled="!isOfferableActive"                
                :class="{ invalid }"
              ></b-form-input>
              <form-errors-manager :errors="errors" />
            </b-form-group>
          </div>
        </form-group>
      </b-col>
    </b-row>
    
    
    <b-row>
      <b-button type="submit" pill variant="purple" class="w-100 mt-4"
        >تایید</b-button
      >
    </b-row>

  </b-form>  
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import FormGroup from "../../validator/FormGroup";
import FormErrorsManager from "../../validator/FormErrorsManager.vue";
import { required, requiredIf, numeric, minLength } from "vuelidate/lib/validators";
import { dateConverter } from "@moeinmdn/mixitweb-front-modules/src/plugin/class/Converter";
import VuePersianDatetimePicker from 'vue-persian-datetime-picker';

export default {
  name: "FormOffer",
  props: ["form", "submit"],
  components: { FormGroup, FormErrorsManager, VuePersianDatetimePicker },
  data() {
    return {
     types: [
        { text: "همه", value: null },
        { text: "محصول", value: "product" },
        { text: "برند", value: "brand" },
        { text: "دسته بندی", value: "category" },
      ],
    };
  },
  validations: {
    form: {
      name: { required },
      code: { required },
      active_at: { required },
      expire_at: { required },
      price: { required, numeric },
      on_delivery_price: { numeric },
      HowManyCanBeUsed: { required, numeric },
      offerable_type: {},
      offerable_id: { 
        required: requiredIf(
          function() { return this.isOfferableActive }
        )
      },
    },
  },
  methods: {
    dateConverter,
    isValid() {
      this.$v.$touch();
      return !this.$v.$invalid;
    },
    onSubmit() {
      if (this.isValid())
        this.submit(this.form);
    },
  },
  computed: {
    isOfferableActive() {
      return (this.form.offerable_type != null)
    }
  }
};
</script>

<style scoped>
</style>